'use client';

import { cn } from '@ahm/common-helpers';
import React from 'react';
import Ahamove from '@/../public/static/icons/ahamove.svg';

export type DealMode = 'exclusive' | 'today';

type Props = {
  activeMode: DealMode;
  onModeChange: (mode: DealMode) => void;
  className?: string;
};

export default function DealSwitchTabs({
  activeMode,
  onModeChange,
  className,
}: Props) {
  return (
    <div
      className={cn(
        'col-span-full mb-6 bg-[#FFF8F2] -mx-4 px-4 border-t-8',
        className
      )}
    >
      <div className="flex rounded-2xl py-2">
        <button
          onClick={() => onModeChange('exclusive')}
          className={cn(
            'flex-1 flex items-center justify-center gap-2 px-4 py-2 rounded-2xl font-semibold text-sm transition-all duration-200',
            activeMode === 'exclusive'
              ? 'bg-white text-secondary-50 shadow-sm'
              : 'text-neutral-60 hover:text-neutral-80'
          )}
        >
          <Ahamove className="w-6 h-auto" />
          <span className="font-bold">ĐỘC QUYỀN</span>
        </button>

        <button
          onClick={() => onModeChange('today')}
          className={cn(
            'flex-1 flex items-center justify-center gap-2 px-4 py-2 rounded-2xl font-semibold text-sm transition-all duration-200',
            activeMode === 'today'
              ? 'bg-white text-primary-60 shadow-sm'
              : 'text-neutral-60 hover:text-neutral-80'
          )}
        >
          <span className="text-lg">⚡</span>
          <span className="text-primary-60 font-bold">DEAL HÔM NAY</span>
        </button>
      </div>
    </div>
  );
}
